// extracted by mini-css-extract-plugin
module.exports = {"text":"HeaderParagraph-module--text--3rrq5","title":"HeaderParagraph-module--title--3fESb"};